import { BREAKPOINTS } from "constants/common";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 14px;
  max-width: 1140px;
  margin: auto;

  @media (min-width: ${BREAKPOINTS.maxTablet}px) {
    padding: 0 7%;
  }
`;
